import React, {useEffect, useMemo} from 'react'
import {useSelector} from "react-redux";
import {Link, useLocation} from "react-router-dom";
import {
  CCreateElement,
  CSidebar,
  CSidebarNav,
  CSidebarNavDivider,
  CSidebarNavTitle,
  CSidebarMinimizer,
  CSidebarNavDropdown,
  CSidebarNavItem,
} from '@coreui/react'

import CIcon from '@coreui/icons-react'
import {States} from "../../store/ducks/rootReducer";
import useModuloAtual from "../../services/useModuloAtual";
import {itensDoMenu} from "../../services/acesso";
import SeletorModulo from "./seletorModulo";
import useSidebar, {definirSidebar} from "../../services/useSidebar";

// O menu sai do acesso que o backend mandou no login (#484909): so as
// paginas liberadas do modulo escolhido no seletor da faixa da marca.
const TheSidebar = () => {
  // Aberta no desktop; no celular abre pelo botao de menu do cabecalho (#480058).
  const show = useSidebar();
  const location = useLocation();
  const acesso = useSelector((state: States) => state.login.data?.acesso);
  const modulo = useModuloAtual();

  const itens = useMemo(() => itensDoMenu(acesso, modulo), [acesso, modulo]);

  // No celular, escolher uma pagina fecha o menu. Na raiz (login e troca de
  // modulo) nao ha tela, so o menu: ele fica aberto.
  useEffect(() => {
    definirSidebar(location.pathname === '/' ? true : 'responsive');
  }, [location.pathname]);

  return (
    <CSidebar
      show={show}
      onShowChange={(valor: any) => definirSidebar(valor)}
    >
      {/* Nao e o CSidebarBrand: ele e um link, e o seletor e um botao. */}
      <div className="c-sidebar-brand marca-modulo">
        <Link to="/" className="marca-modulo-logo" title="Panorama Sistemas: página inicial">
          <CIcon name="logoHeader" height={30} className="marca-modulo-logo-completo"/>
          <CIcon name="logoMarca" height={30} className="marca-modulo-logo-recolhido"/>
        </Link>
        <SeletorModulo/>
      </div>
      <CSidebarNav>
        <CCreateElement
          items={itens}
          components={{
            CSidebarNavDivider,
            CSidebarNavDropdown,
            CSidebarNavItem,
            CSidebarNavTitle
          }}
        />
      </CSidebarNav>
      <CSidebarMinimizer/>
    </CSidebar>
  )
}

export default React.memo(TheSidebar)
